export class BdMapHeatMapUtil {

  public static getDataMaxValue(keys: string[], data: { [id: number]: number }): number {
    let maxValue = 0;

    keys.forEach(id => {
      maxValue = maxValue >= data[id] ? maxValue : data[id]
    });

    console.log(maxValue)

    return maxValue;
  }

  public static getDataExtremeValues(
    keys: string[],
    data: { [id: number]: number }
  ): { min: number | null, max: number | null } {
    let max: number = null;
    let min: number = null;

    keys.forEach(id => {
      if (max !== null) {
        max = max >= data[id] ? max : data[id];
      } else {
        max = data[id];
      }

      if (min !== null) {
        min = min <= data[id] ? min : data[id];
      } else {
        min = data[id];
      }
    });

    return {min, max};
  }
}
